import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { retrieveToken } from 'services/auth.service';
import CreateOrLoginDisplay from './CreateOrLoginDisplay';

const nextPageRoute = '/setup/accountcreated';
const loginPageRoute = '/login';

function validateForm(form) {
  const errors = {};
  if (form.Password !== form.PasswordConfirm) {
    errors.Password = 'Passwords do not match';
  }

  if (!form.Password) {
    errors.Password = 'Password is required';
  }

  if (!form.Email) {
    errors.Email = 'Email is required';
  }

  if (Object.keys(errors).length !== 0) {
    return errors;
  }
  return null;
}

class CreateOrLoginContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    createUser: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    loggedIn: PropTypes.bool.isRequired
  };

  state = {
    form: {
      Email: '',
      Password: '',
      PasswordConfirm: ''
    },
    error: ''
  };

  componentDidUpdate(prevProps) {
    if (this.props.loading !== prevProps.loading && this.props.loggedIn) {
      const token = retrieveToken();
      if (token != null) {
        this.props.history.push(nextPageRoute);
      }
    }
  }

  handleOnChange = (newValue) => {
    this.setState({ form: newValue }, () => {
      if (!this.isFormValid()) {
        this.setState(prevState => ({ error: Object.values(validateForm(prevState.form))[0] }));
      } else {
        this.setState({ error: '' });
      }
    });
  };

  onSubmit = () => {
    const { form } = this.state;
    if (this.isFormValid()) {
      this.props.createUser(form.Email, form.Password);
    } else {
      this.setState(prevState => ({ error: Object.values(validateForm(prevState.form))[0] }));
    }
  };

  signInRedirect = () => {
    this.props.history.push(loginPageRoute);
  };

  isFormValid() {
    const { form } = this.state;
    return validateForm(form) === null;
  }

  render() {
    return (
      <CreateOrLoginDisplay
        value={ this.state.form }
        onChange={ this.handleOnChange }
        error={ this.state.error }
        onSubmit={ this.onSubmit }
        signInRedirect={ this.signInRedirect }
        isFormValid={ this.isFormValid() }
      />
    );
  }
}

export default withRouter(CreateOrLoginContainer);
